// ===================================
// KAIXO - Push Notifications (Web)
// ===================================

const API_URL = process.env.REACT_APP_API_URL || 'https://backend-dlmm.onrender.com/api';

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = window.atob(base64);
    return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

export async function registerPushNotifications(userId) {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    // En Capacitor (APK) NO registramos SW porque:
    // 1) Causa cache stale de index.html y main.*.js
    // 2) Las push notifications nativas se manejan por FCM, no por SW
    const isCapacitor = window.location.hostname === 'localhost' &&
                        (window.location.protocol === 'https:' ||
                         window.location.protocol === 'capacitor:');
    if (isCapacitor) {
        console.log('[push] Capacitor detectado, omitiendo registro SW');
        return;
    }

    try {
        // Registrar service worker
        const registration = await navigator.serviceWorker.register('/sw.js');
        await navigator.serviceWorker.ready;

        // Pedir permiso
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        // Obtener VAPID public key del backend
        const keyRes = await fetch(`${API_URL}/users/vapid-public-key`);
        const keyData = await keyRes.json();
        if (!keyData.key) return;

        // Suscribir al push
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(keyData.key)
        });

        // Enviar suscripción al backend
        await fetch(`${API_URL}/users/push-subscription`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId, subscription })
        });

        console.log('✅ Push notifications activadas');
    } catch (err) {
        console.warn('⚠️ Push no disponible:', err.message);
    }
}
